/* eslint-disable import/prefer-default-export */
import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  surfaceTypeListRequest,
  surfaceTypeListSuccess,
  surfaceTypeListFailure,
} = createActions({
  SURFACE_TYPE_LIST_SUCCESS: json => json.surface_types,
}, 'SURFACE_TYPE_LIST_REQUEST', 'SURFACE_TYPE_LIST_FAILURE');

export function requestSurfaceTypesList() {
  return (dispatch) => {
    dispatch(surfaceTypeListRequest());
    return request('surface_types')
      .then(({ json }) => {
        dispatch(surfaceTypeListSuccess(json));
      },
      (error) => {
        dispatch(surfaceTypeListFailure(error));
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/surface_types.js